import { Routes } from '@angular/router';

export const POSTAL_CODES_ROUTES: Routes = [
  {
    path: 'postal-codes',
    loadComponent: () =>
      import('./postal-codes-list/postal-codes-list.component')
        .then(m => m.PostalCodesListComponent),
  }
];
